export function isPrintableAscii(str) {
  return /^[ -~]+$/.test(str);
}
